
exports.getLocal = (original) => {
  if (!original) return {
    date: '',
    time: '',
    datetime: ''
  };

  if (typeof original == 'string') original = new Date(original);
  let result = {
    date: 
      (original.getUTCDate() < 10 ? '0' : '') + original.getUTCDate() + 
      '.' +
      (original.getUTCMonth() + 1 < 10 ? '0' : '') + (original.getUTCMonth() + 1) +
      '.' +
      original.getUTCFullYear()
    ,
    time: 
      (original.getUTCHours() < 10 ? '0' : '') + original.getUTCHours() +
      ':' +
      (original.getUTCMinutes() < 10 ? '0': '') + original.getUTCMinutes() +
      ':' +
      (original.getUTCSeconds() < 10 ? '0' : '') + original.getUTCSeconds()
  };
  result.datetime = result.date + ' ' + result.time;
  return result;
}

exports.getStartDateFromISO = (isoString) => {
    if (!isoString) return '';

    let [y, m, d] = isoString.split('-');

    let dt = new Date(0);
    dt.setUTCDate(d);
    dt.setUTCMonth(m - 1);
    dt.setUTCFullYear(y);
    dt.setUTCHours(0, 0, 0, 0);

    return dt;
}

exports.getFinishDateFromISO = (isoString) => {
  if (!isoString) return '';

  let [y, m, d] = isoString.split('-');

  let dt = new Date(0);
  dt.setUTCMonth(m - 1);
  dt.setUTCFullYear(y);
  dt.setUTCHours(0, 0, 0, 0);
  dt.setUTCDate(Number(d) + 1);

  return new Date(dt - 1);
}

exports.haveCommonSegment = (sd1, fd1, sd2, fd2) => {
  if (!sd1) sd1 = new Date(0)
  else sd1 = new Date(sd1);

  if (!sd2) sd2 = new Date(0)
  else sd2 = new Date(sd2);
  
  if (!fd1) fd1 = new Date(3000, 1, 1)
  else fd1 = new Date(fd1);

  if (!fd2) fd2 = new Date(3000, 1, 1)
  else fd2 = new Date(fd2);

  //alert(`${sd1} ${fd1} ${sd2} ${fd2}`);

  if (sd1 < sd2) {
    return sd2 <= fd1;
  } 
  else {
    return sd1 <= fd2;
  } 
}

exports.restoreDatetimes = (obj) => {
  //alert(obj);
  if (obj instanceof Array) {
    obj.forEach(elem => this.restoreDatetimes(elem));
  } else {
    if (obj instanceof Object) {
      for (let key of Object.keys(obj)) {
        if (key == 'createdAt' || key == 'updatedAt' || key == 'startedAt' || 
            key == 'finishedAt' || key == 'publicAt'
        ) {
          if (obj[key]) obj[key] = new Date(obj[key]);
        }
          
        if (obj[key] instanceof Object) {
          this.restoreDatetimes(obj[key]);
        }
      }
    }
  }
  
  return obj;
}

exports.getISOFromDate = (dt) => {
  return dt ? (new Date(dt)).toISOString().substr(0, 10) : '';
}